 const MyPublishedActivitiesLoader = ({params})=>  {
    return {
        id: params.id,
    };
}

export default MyPublishedActivitiesLoader;